import React from 'react';
import {
  faInfoCircle,
  faClipboardList,
  faSquareParking,
  faDollarSign,
  faFileWaveform,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from '../css/homeCard.module.css';
import { Link } from 'react-router-dom';

function MainTabContent() {
  return (
    <div className={styles.topContainer}>
      <Link to="/topInfo">
        <div className={styles.contentsContainer}>
          <div>
            <h6>
              {' '}
              What you need to know before applying?{' '}
              <FontAwesomeIcon icon={faInfoCircle} size={48} color="blue" />
            </h6>
          </div>

          <div className={styles.beforeSignUp}></div>
        </div>
      </Link>

      <Link to="/Policies">
        <div className={styles.contentsContainer}>
          <div>
            <h6>
              {' '}
              What you need to know after you sign up?{' '}
              <FontAwesomeIcon icon={faClipboardList} size={48} color="blue" />
            </h6>
          </div>
          <div className={styles.afterSignUp}></div>
        </div>
      </Link>

      <Link to="/Applications">
        <div className={styles.contentsContainer}>
          <div>
            <h6>
              {' '}
              Parking Applications and Forms.{' '}
              <FontAwesomeIcon icon={faFileWaveform} size={48} color="blue" />
            </h6>
          </div>
          <div className={styles.forms}></div>
        </div>
      </Link>

      <Link to="/AltParkingTab">
        <div className={styles.contentsContainer}>
          <div>
            <h6>
              {' '}
              Alternate Parking Near My campus.{' '}
              <FontAwesomeIcon icon={faSquareParking} size={48} color="blue" />
            </h6>
          </div>
          <div className={styles.alternateParking}></div>
        </div>
      </Link>

      <Link to="/NestedNav">
        <div className={styles.contentsContainer}>
          <div>
            <h6>
              {' '}
              NYP Parking Daily and Monthly Rates{' '}
              <FontAwesomeIcon icon={faDollarSign} size={48} color="blue" />
            </h6>
          </div>
          <div className={styles.rates}></div>
        </div>
      </Link>
    </div>
  );
}
export default MainTabContent;
